module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1",
    attrs: {
      "id": "auto_bookmark_toc_4"
    }
  }, [_c('span', [_vm._v("Chapter Two")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "0.93em"
    }
  }, [_vm._v("WEB DESIGN")]), _vm._v(" was a perfect job for someone allergic to anything public-facing.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle had tried, years before, at all those low-level entry jobs that are pawned off on anyone too young for a mortgage. Strangers still freaked him out. He’d been an anxious cashier who froze if the phone rang when he was ringing up a sale. His days as a server and a personal assistant had proven equally pitiful.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But no, Kyle was "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("meant ")]), _vm._v("to be in web design. The mix of graphic design and technical fussiness was ideal for Kyle’s temperament and over the past ten years he’d built a solid client base that paid him well. Sure, the work sometimes kept him at his desk late, but there were rarely emergency calls from clients. And the ample flex in his schedule was much less grueling than watching the clock on the old nine-to-five.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was a stroke of good fortune that he’d even found the job. Like most people of his generation, Kyle’s childhood was shaped by the constant evolution of technology. A love of video games paired with a lower-middle-class background made a certain degree of technical know-how a necessity.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Web work gave Kyle the option of working from home, but his townhouse was a smallish three-bedroom. Unless he wanted Alice and Zach to share a room—and he didn’t—the options were between his own bedroom and his living room. It wasn’t ideal.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Luckily, the design agency he worked with had no shortage of office space. The infrequent socialization with coworkers was on Kyle’s terms and generally productive—the other designers on the books often swapped code, offered shortcuts, or reminded each other of deadlines. Going through an agency meant that Kyle didn’t have to deal with billing, something he personally found awkward to tackle by himself. It also presented some unique challenges—puzzles, knots in the programming that Kyle could slowly work out.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Almost everything was handled through e-mail, which kept frustrations contained and personal drama to a minimum. The gigs might get odd at times, but they paid for the weirdness they brought to the table.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Today was a perfect example. This particular client had sent examples of other websites she found appealing. “I guess I like these designs, but the color scheme isn’t really "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("me")]), _vm._v(", you know? I like spicier colors. Maybe orange and green, you know? Some sizzle!”")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle stared at his computer for about fifteen minutes before deciding on the most polite way to say, “But this is for a funeral home?” As it turned out, the most tactful route was to find pages with lighter but more muted colors that also represented professionals in more solemn fields. Maybe something less funereal might help her stand out. He revised his proposal around the idea of “"), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("No cliches. Think outside the coffin")]), _vm._v(".” He took a couple of hours to dig up other websites he had personally designed for more serious professions, drew a mock-up, and sent them over.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Once that was taken care of, Kyle dove into a series of web pages he’d been debugging. The client had switched domains and largely copy-and-pasted several of their key elements. Unfortunately, the format was notably bug-ridden. There were odd paragraph breaks, freaky font changes, and misplaced indents throughout. Fortunately, most of them had easy HTML fixes.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle usually didn’t pay attention to every image on a typical website. Most of them were a blur, especially after ten years of web design. But one in particular caught his eye.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Two children, a girl Alice’s age and a boy Zach’s age. The boy in the picture even had glasses, though they weren’t as thick as Zach’s. They were both opening presents, faces beaming at whatever was inside. Their doting parents looked on with an air of smug contentment, curled up together on an unseen couch, a cup of hot cocoa between them.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("The image looked so "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("balanced. ")]), _vm._v("Two and two. Two parents, two children.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Something in his chest tightened at that.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("Christmas gifts.")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Kyle was determined that despite being a single father, Alice and Zach wouldn’t be shorted for the holidays. Their fractured family might not have been Kyle’s fault, but it "), _c('span', {
    staticStyle: {
      "font-style": "italic",
      "font-size": "1.00em"
    }
  }, [_vm._v("definitely")]), _vm._v(" wasn’t his children’s.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was lucky that this particular page only had a few common problems to untangle. Kyle’s mind kept wandering. A job that should’ve taken him five minutes took close to half an hour. With a little work and some motivational muttering to himself, he was able to soldier through.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("By the time he wrapped everything up, Kyle was able to start his lunch break early.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("Perfect.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("He donned his wool coat and checked that his gloves were in his pockets, ready to face the holiday crowds.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("It was time to do some Christmas shopping.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0